const cs_CZ = {
    homepage_title: 'Stáhnout CalendarTask mobilní verzi pomocí QR kódu',
    homepage_slogn: 'CalendarTask mobilní verze',
    homepage_ios_download: 'App Store v kontrole...',
    homepage_download: 'Stáhnout',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Stáhnout CalendarTask mobilní verzi pomocí QR kódu',
    phonedownload_slogan: 'Synchronizace s PC a tabletem, poznámky všude',
    phonedownload_send_vip: 'Nainstalujte aplikaci a získejte VIP členství',
    phonedownload_screenshot: 'Snímek obrazovky',
    phodedownload_macos: 'CalendarTask verze macOS',
    phodedownload_windows: 'CalendarTask verze Windows',
    phodedownload_otherbutton: 'Zobrazit nyní',
    phodedownload_about: 'Kontakt',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Bez reklam',
    feature_easy: 'Měsíční zobrazení, jednoduché a snadné',
    feature_reminder: 'Vlastní připomenutí',
    feature_countdown: 'Odpočítávání výročí',

    vip_task_succ: 'Úspěch. Stáhněte aplikaci pro aktivaci VIP',
    vip_task_error: 'Přijetí selhalo',

    group_slogn: 'Pozvánka CalendarTask tým',

    tt_title: 'CalendarTask',
    tt_share_1: 'Sdíleno s vámi',
    tt_share_2: 'Rozvrh',
    tt_share_show_1: 'Naskenujte QR kód aplikací "CalendarTask", PC a telefon zobrazí',
    tt_share_show_2: 'rozvrh',
    tt_share_scan_1: 'Skenovat',
    tt_share_scan_2: 'aplikací "CalendarTask"',
    tt_share_succ: 'Synchronizace úspěšná',

    v2_copyright: 'Kontakt service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Všechna práva vyhrazena.',
    v2_download_appstore: 'Stáhnout v App Store',
    v2_download_googleplay: 'Dostupné v Google Play',

    v2_main_title: 'CalendarTask Mobilní',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobilní',
    v2_main_description: 'Vyhledejte <span class="name">CalendarTask</span> v App Store nebo Google Play',
    v2_download_ios: 'Stáhnout iOS',
    v2_download_android: 'Stáhnout Android',
    v2_download_harmonyos: 'Stáhnout HarmonyOS',
    v2_sync_status: 'Synchronizace dokončena! 1 nahráno, 0 staženo',
    v2_feature_title: 'Synchronizace dat více zařízení',
    v2_feature_description: 'Synchronizace mezi telefonem, tabletem a PC'
};
export default cs_CZ;
